<template>
  <div id="top" ref="hearder">
    <div class="welcome">
      <div class="contain clearfix" v-show="!isLogin">
        <div class="loginAndRegister" style="float:left"><router-link to="/login">登录</router-link> | <router-link to="/register">注册</router-link></div>
        <!-- <div><router-link to="">联系我们</router-link> | <router-link to="">服务热线</router-link></div> -->
        <div style="float:right">服务热线: {{phone}}</div>
      </div>
      <div class="contain loged clearfix" v-show="isLogin">
        <div style="float:left"> <span class="goBack" @click="goBack">返回</span> <router-link to="/usercenter">用户中心</router-link> | <span>欢迎,{{userData.username}} </span> | <router-link to="/usercenter">新消息(0)</router-link> | <a href="" @click.prevent="handleLogOut">退出</a> </div>
        <!-- <div><router-link to="">联系我们</router-link> | <router-link to="">服务热线</router-link></div> -->
        <div style="float:right">服务热线: {{phone}}</div>
      </div>
    </div>
    <div class="logoContain" v-show="show">
      <div class="contain">
        <!-- <div class="logo" style="float:left">
          <h1>
            <a href="#">
            </a>
          </h1>
          <img src="../../assets/images/logo.png" alt="" width="105px" height="30px">
           &nbsp;<span class="line">|</span>
          <span class="title">高端智能设备一站式服务平台</span>
        </div> -->
        <logo></logo>
        <div class="search" style="float:right">
          <input type="text" placeholder="输入要搜索的设备" v-model="machine"/>
          <!-- <m-select placeholder="设备" class="select">
          </m-select> -->
          <div class="schBtn" @click="handleSearch"><img src="../../assets/images/search_03.png" alt=""></div>
        </div>
      </div>
    </div>
    <tab :itemList = "list" @click="handleClick" v-show="show"></tab>
  </div>
</template>

<script>
import Tab from '../tab/Tab'
import MSelect from '../mselect/MSelect'
import Logo from '../logo/Logo'
import { mapGetters } from 'vuex'
import { logOutSrv } from '../../api/home/home'
import constants from '../../common/constants'

export default {
  data(){
    return {
      phone:constants.phoneNumber,
      list:[
        {name:'首页',link:'/'},
        {name:'机电设备',link:'/productlist',
        // id:'mat',
        // children:[
        //   {name:'车床',code:'LATHE',link:''},
        //   {name:'加工中心',link:'',code:'MACHINING_CENTER'},
        //   {name:'数控铣床',code:'CNC_MACHINE',link:''},
        //   {name:'镗铣床',code:'BORING_MACHINE',link:''},
        //   {name:'锻压机床',code:'FORGING_MACHINE' ,link:''},
        //   {name:'电火花/线切割',code:'ELECTRIC_CUTTING',link:''},
        //   {name:'磨床',code:'GRINDING_MACHINE',link:''},
        //   {name:'钻床',code:'DRILLING_MACHINE',link:''},
        //   {name:'注塑机',code:'INJECTION_MACHINE',link:''},
        //   {name:'专用机床',code:'SPECIAL_MACHINE',link:''},
        //   {name:'检测设备',code:'DETECTION_EQUIPMENT',link:''},
        //   {name:'机床附件',code:'MACHINE_ACCESSORIES',link:''},
        //   ]
        // children:attr.machineTypeList
        },
        {name:'机电厂商',link:'/merchantlist'},
        {name:'我是买家',link:'',id:'buy',children:[
          {name:'发需求',link:'/asktobuy'},
          {name:'找设备',link:'/productlist'},
          {name:'找厂商',link:'/merchantlist'},
          {name:'找资金',link:'/financingplan'}
        ]},
        {name:'我是卖家',link:'',id:'sel',children:[
          // {name:'我要入驻',link:'/businessenter'},
          {name:'找买家',link:'/entireBuy'},
          {name:'找资金',link:'/financingplan'},
          // {name:'发产品',link:''}
        ]},
        {name:'我们的服务',link:'/ourservices'},
        {name:'关于我们',link:'/about'}
      ],
      isLogin:false,
      typeSelected:1,
      machine:'',//搜索的设备
      userData:''
    }
  },
  components:{
    Tab,
    MSelect,
    Logo
  },
  methods:{
    handleClick(code,pathName){ //点击下拉菜单到响应的页面
      if(code){
        this.$router.push({path:pathName,query:{machineNo:code}})
      }

    },
    goBack(){
      window.history.go(-1) //不刷新
      // window.opener.location.reload();
    },
    handleLogOut(){ //点击退出
      let params = {}
      logOutSrv(params).then( () => {
        this.$storage.clear('__USD')
        location.reload()
      })
      // this.$store.dispatch('loginOut').then(() => {
      //   location.reload()
      // })
    },
    handleSearch(){ //点击搜索
      this.$router.push({path:'/productlist',query:{machineName:this.machine}})
    },
    handleClear(){
      this.machine = ''
    }
  },
  computed:{
    ...mapGetters({
        attr:'home/getAttrData'
      })
  },
  mounted(){
    this.$store.dispatch('home/getMachineAttributeAction',{})
    const userData = this.$storage.get('__USD');
    if(userData){
      this.isLogin = true;
      this.userData = userData;
    }
  },
  props:{
    show:Boolean
  }
}
</script>

<style lang="less">
@borderColor:#a8a8a8;
  #top{
    // height: 285px;
    .contain{
      width: 1200px;
      margin: 0 auto;
    }
    .welcome{
      line-height:48px;
      font-size: 14px;
      background-color:#e4e4e4;
      .loginAndRegister{
        a{
          color: #6d7bec;
        }
      }
      .loged{
        div:nth-child(1){
          a{
            color: #6d7bec
          }
        }
      }
      div:nth-child(2){
        a{
          color: #333;
        }
      }
      .goBack{
        cursor: pointer;
      }
    }
    .logoContain{
      height: 85px;
      .contain{
        padding-top: 30px;
        // .logo{
        //   display: flex;
        //   align-items: center;
        //   // height: 40px;
        //   overflow: hidden;
        //  padding-left: 10px;
        // }
      }
      .search{
        width: 345px;
        height: 35px;
        border: 1px solid @borderColor;
        display: flex;
        border-radius: 21px;
        // margin-top: 60px;
        box-sizing: border-box;
        padding-left: 25px;
        margin-top: -4px;
        input{
          display: block;
          width: 265px;
          line-height: 33px;
          height: 33px;
          border-right: 1px solid #ccc;
        }
        .select{
          width: 85px;
          border-right: 1px solid @borderColor;
          height: 34px;
          line-height: 34px;
          margin-top: 3px;
          select{
            width: 100%;
            height: inherit;
          }
        }
        .schBtn{
          position: relative;
          width: 60px;
          cursor: pointer;
          // border-radius: 20px;
          border-bottom-right-radius: 20px;
          border-top-right-radius: 20px;
          >img{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-55%,-45%);
          }
        }
      }
    }
    // .line{
    //   font-size: 26px;
    //   padding:0 15px;
    // }
    // .title{
    //   font-size: 22px;
    // }
  }
</style>



// WEBPACK FOOTER //
// src/components/top/top.vue